import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { IncidentType } from '../models/enums/incident-type.enum';
import { IncidentTypeUi } from '../models/incident-type-ui.enum';

@Injectable()
export class IncidentTypeService extends BaseApiService {
    public getIncidentType(id: number) {
        return this.get(`Incident/Type/${id}`);
    }

    public getIncidentTypeByViolationCodes(vilationCode: string, occurrenceDate: any) {
        return this.get(`Incident/incidentType/${vilationCode}/${occurrenceDate}`);
    }

    public getACD(acdCodeId: number) {
        return this.get(`incident/acdCode/${acdCodeId}`);
    }

    public getIncidentTypeUi(incidentTypeId: number): IncidentTypeUi {

        if (incidentTypeId == IncidentType.FraudAlertNotificationVehicle) {
            return IncidentTypeUi.FraudVehicle;
        } else if ((incidentTypeId == IncidentType.FraudAlertNotificationAllVehicles) ||
                   (incidentTypeId == IncidentType.FraudAlertNotificationCustomer) ||
                   (incidentTypeId == IncidentType.FraudAlertNotificationDriverLicense) ||
                   (incidentTypeId == IncidentType.FraudForCDLCancel) ||
                   (incidentTypeId == IncidentType.FraudforCDLDisqualification) ||
                   (incidentTypeId == IncidentType.FraudForIDCardCancel) ||
                   (incidentTypeId == IncidentType.FraudForNonCDLCancel) ||
                   (incidentTypeId == IncidentType.FraudForNonCDLSuspension) ||
                   (incidentTypeId == IncidentType.FraudForRegistrationCancel)
        ) {
            return IncidentTypeUi.FraudCustomer;
        } else if ((incidentTypeId == IncidentType.FinancialResponsibilityNoInsurance) ||
                   (incidentTypeId == IncidentType.FinancialResponsibilityReinstatementFee) ||
                   (incidentTypeId == IncidentType.FRAccidentReinstatementFee)
        ) {
            return IncidentTypeUi.MandatoryInsurance;
        } else if (incidentTypeId == IncidentType.AbandonedVehicle) {
            return IncidentTypeUi.AbandonedVehicle;
        } else if ((incidentTypeId == IncidentType.RegistrationDocumentationIncomplete) ||
                   (incidentTypeId == IncidentType.TitleDocumentationIncomplete)
        ) {
            return IncidentTypeUi.DocumentIncomplete;
        } else if (incidentTypeId == IncidentType.TTEAPIncident) {
            return IncidentTypeUi.Tteap;
        } else if (incidentTypeId == IncidentType.FinancialResponsibilityAccident) {
            return IncidentTypeUi.FinancialResponsibility;
        } else if (incidentTypeId == IncidentType.ForfeitureLien) {
            return IncidentTypeUi.OpsOfLawLienVehicle;
        } else if ((incidentTypeId == IncidentType.ChildSupportLien) ||
                   (incidentTypeId == IncidentType.DESLien) ||
                   (incidentTypeId == IncidentType.DORLien) ||
                   (incidentTypeId == IncidentType.DivorceDecreeLien) ||
                   (incidentTypeId == IncidentType.RacketeeringLien) ||
                   (incidentTypeId == IncidentType.RestitutionLien)
        ) {
            return IncidentTypeUi.OpsOfLawLienCustomer;
        } else if (incidentTypeId == IncidentType.AbandonedVehicleFeeDue) {
            return IncidentTypeUi.AbandonedVehicleFee;
        } else if (incidentTypeId == IncidentType.CivilPenaltyHighway) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.CivilPenaltyIgnitionInterlock) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.CivilPenaltyVehicleForHire) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.Subpoenas) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.ForeignBasedIRPInterest) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.ThreerdPartyIRPAudit) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.ThreerdPartyIFTAAudit) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.VehicleForHire) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.Cardlock) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.AircraftAudits) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.AircraftInterest) {
            return IncidentTypeUi.FinanceCollection;
        } else if (incidentTypeId == IncidentType.NSFCancellation) {
            return IncidentTypeUi.NSFCancellation;
        } else if (incidentTypeId == IncidentType.NSFPenaltyDue) {
            return IncidentTypeUi.NsfPenaltyDue;
        } else if (incidentTypeId == IncidentType.NonpaymentOfJudgment) {
            return IncidentTypeUi.NonpaymentOfJudgment;
        } else if (incidentTypeId == IncidentType.FailedToCalibrateIID) {
            return IncidentTypeUi.FailureToComplyWithCIID;
        } else if (incidentTypeId == IncidentType.FinancialResponsibilityCourtOrdered4135B) {
            return IncidentTypeUi.FinancialResponsibilityCourtOrdered4135B;
        } else if (incidentTypeId == IncidentType.FinancialResponsibilityCourtOrdered4135C) {
            return IncidentTypeUi.FinancialResponsibilityCourtOrdered4135C;
        } else if (incidentTypeId == IncidentType.FailedVisionExam) {
            return IncidentTypeUi.FailedVisionExam;
        } else if ((incidentTypeId == IncidentType.FailedVisionExam) ||
                   (incidentTypeId == IncidentType.FinancialResponsibilityCourtOrdered4135B) ||
                   (incidentTypeId == IncidentType.FinancialResponsibilityCourtOrdered4135C) ||
                   (incidentTypeId == IncidentType.FailedVisionExam) ||
                   (incidentTypeId == IncidentType.FinancialResponsibilityReinstatementFee) ||
                   (incidentTypeId == IncidentType.FRAccidentReinstatementFee) ||
                   (incidentTypeId == IncidentType.FailedToMaintainSR22) ||
                   (incidentTypeId == IncidentType.FraudforCDLDisqualification) ||
                   (incidentTypeId == IncidentType.UnableToPassTest) ||
                   (incidentTypeId == IncidentType.FailureToMakeAppt30Days) ||
                   (incidentTypeId == IncidentType.FailureToRetestOrFailureOfTest) ||
                   (incidentTypeId == IncidentType.ImminentHazard) ||
                   (incidentTypeId == IncidentType.FailureToSurrenderCDL) ||
                   (incidentTypeId == IncidentType.TrafficSurvivalSchoolRequired) ||
                   (incidentTypeId == IncidentType.FailureToRespondToDriverLicenseUpdate) ||
                   (incidentTypeId == IncidentType.InimicalThreat) ||
                   (incidentTypeId == IncidentType.MedicalReportRequired) ||
                   (incidentTypeId == IncidentType.VisionReportRequired) ||
                   (incidentTypeId == IncidentType.SubstanceAbuseEvaluationRequired) ||
                   (incidentTypeId == IncidentType.ImproperUseOfLicense)
        ) {
            return IncidentTypeUi.CommonIncident;
        } else if ((incidentTypeId == IncidentType.ImpliedConsent) ||
                   (incidentTypeId == IncidentType.AdminPerSeNoBAC) ||
                   (incidentTypeId == IncidentType.AdminPerSeDrugs) ||
                   (incidentTypeId == IncidentType.AdminPerSe)
        ) {
            return IncidentTypeUi.LawEnforcementIncident;
        }
    }
}
